
import Vue from 'vue';
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(
    'section',
    { staticClass: 'a404page' },
    [
      _c('secondary-nav'),
      _c('div', { staticClass: 'su-body' }, [
        _c('div', { staticClass: 'a404page-section container' }, [_vm._m(0), _c('footer-row')], 1),
      ]),
    ],
    1,
  );
};
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c;
    return _c('div', { staticClass: 'row' }, [
      _c('div', { staticClass: 'col-2 void-column' }),
      _c('div', { staticClass: 'col-12 col-md-10' }, [
        _c('div', { staticClass: 'row' }, [
          _c('div', { staticClass: 'col-12' }, [_c('h1', [_vm._v(' 404 - NOT FOUND ')])]),
          _c('div', { staticClass: 'col-12' }, [
            _c('h3', [_vm._v(" We can't find this page on our website. ")]),
          ]),
        ]),
      ]),
    ]);
  },
];

export default Vue.extend({ render, staticRenderFns });
